
import React from 'react';
import { useSessionStore } from '@/store/sessionStore';
import { Badge } from '@/components/ui/badge';
import { Label } from '@/components/ui/label';
import { Folder, File as FileIcon, XIcon, Trash2, Terminal } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';

const AdHocContextPills: React.FC = () => {
  const {
    adHocFiles,
    setAdHocFiles,
    adHocFolders,
    setAdHocFolders,
    adHocCommandOutputs,
    setAdHocCommandOutputs,
    clearAdHocContext,
  } = useSessionStore();

  if (adHocFiles.length === 0 && adHocFolders.length === 0 && adHocCommandOutputs.length === 0) {
    return null;
  }

  return (
    <div className="mb-1 px-1 pb-1 border-b">
      <div className="flex justify-between items-center">
        <Label className="text-xs text-muted-foreground">Ad-hoc Context:</Label>
        <TooltipProvider>
            <Tooltip>
                <TooltipTrigger asChild>
                    <Button variant="ghost" size="icon" className="h-6 w-6" onClick={clearAdHocContext}>
                        <Trash2 className="h-3 w-3 text-muted-foreground" />
                    </Button>
                </TooltipTrigger>
                <TooltipContent>
                    <p>Clear ad-hoc context</p>
                </TooltipContent>
            </Tooltip>
        </TooltipProvider>
      </div>
      <div className="flex flex-wrap gap-1 mt-1">
        {adHocFiles.map(file => (
          <Badge key={file} variant="secondary" className="font-normal">
            <FileIcon className="mr-1.5 h-3 w-3" />
            {file}
            <button onClick={() => setAdHocFiles(f => f.filter(i => i !== file))} className="ml-1.5 rounded-full hover:bg-slate-300 dark:hover:bg-slate-600 p-0.5">
              <XIcon className="h-3 w-3" />
            </button>
          </Badge>
        ))}
        {adHocFolders.map(folder => (
          <Badge key={folder} variant="secondary" className="font-normal">
            <Folder className="mr-1.5 h-3 w-3" />
            {folder}
            <button onClick={() => setAdHocFolders(f => f.filter(i => i !== folder))} className="ml-1.5 rounded-full hover:bg-slate-300 dark:hover:bg-slate-600 p-0.5">
              <XIcon className="h-3 w-3" />
            </button>
          </Badge>
        ))}
        {adHocCommandOutputs.map((output, index) => (
          <Badge key={index} variant="secondary" className="font-normal">
            <Terminal className="mr-1.5 h-3 w-3" />
            <span className="truncate max-w-[20rem]">{`Output: "${output.substring(0, 50)}..."`}</span>
            <button onClick={() => setAdHocCommandOutputs(o => o.filter((_, i) => i !== index))} className="ml-1.5 rounded-full hover:bg-slate-300 dark:hover:bg-slate-600 p-0.5">
              <XIcon className="h-3 w-3" />
            </button>
          </Badge>
        ))}
      </div>
    </div>
  );
};

export default AdHocContextPills;